import { render, staticRenderFns } from "./status-bar.vue?vue&type=template&id=3789f3c6"
import script from "./status-bar.vue?vue&type=script&lang=js"
export * from "./status-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/frontend_src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3789f3c6')) {
      api.createRecord('3789f3c6', component.options)
    } else {
      api.reload('3789f3c6', component.options)
    }
    module.hot.accept("./status-bar.vue?vue&type=template&id=3789f3c6", function () {
      api.rerender('3789f3c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "status-bar.vue"
export default component.exports